import useMountEffect from '@restart/hooks/useMountEffect';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import STORAGE_KEYS from '@/define/storageKeys';
import { getKeycloakAuthUrl } from '@/helpers/Keycloak';
import useAuthGuard from '@/hooks/useAuthGuard';

export const IntroRoute = () => {
  const navigate = useNavigate();

  useMountEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (!token) {
      window.location.replace(getKeycloakAuthUrl());
      return;
    }

    navigate('/control-center', { replace: true });
  });
};

export const UnprotectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);

  useMountEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token) {
      navigate('/', { replace: true });
      return;
    }

    setLoading(false);
  });

  // 로딩 중인 경우 페이지 노출 방지
  if (isLoading) return;

  return children;
};

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const { connectSSE, disconnectSSE } = useAuthGuard();

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (!token) {
      navigate('/', { replace: true });
      return;
    }

    connectSSE(token);
    setLoading(false);

    return () => {
      disconnectSSE();
    };
  }, [location.pathname]);

  // 로딩 중인 경우 페이지 노출 방지
  if (isLoading) return;

  return children;
};
